import React from 'react'
import PropTypes from 'prop-types'
import './UpdateNotifier.scss'

const UpdateNotifierView = ({ updateAvailable }) => (
  <div
    className={`update-version-notification${updateAvailable ? ' visible' : ''}`}
  >
    <div className='update-version-notification__card'>
      There is a new version available.{' '}
      <button
        type='button'
        className='update-version-notification__action'
        onClick={() => window.location.reload()}
        data-testid='update-notifier-btn'
      >
        Update Now
      </button>
    </div>
  </div>
)

UpdateNotifierView.propTypes = {
  updateAvailable: PropTypes.bool.isRequired,
}

export default UpdateNotifierView
